/* eslint-disable jsx-a11y/alt-text */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Utility from "../utility/utility";
import { landingLogo } from "../assets";

const RoleSelection = () => {
  const navigate = useNavigate();
  const gameData = useSelector((state) => state.joinReducer.data);

  useEffect(() => {
    Utility.isSignedIn(gameData).then((value) => {
      if (value) {
        navigate("/gameboard");
      }
    });
  }, [gameData]);

  const handleAdminClick = () => {
    // Check if already logged in as admin
    const adminToken = localStorage.getItem("adminToken");
    if (adminToken) {
      navigate("/admin/dashboard");
    } else {
      navigate("/admin/auth");
    }
  };

  const handlePlayerClick = () => {
    navigate("/room");
  };

  return (
    <div className="background">
        <div className="container">
          <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
          <div className="text-center join-top">
            <button
              onClick={handlePlayerClick}
              type="button"
              className="btn border-name-button semi-bold"
            >
              Join As Player
            </button>
          </div>
          <div className="text-center join-top">
            <button
              onClick={handleAdminClick}
              type="button"
              className="btn border-name-button semi-bold"
            >
              Join As Facilitator
            </button>
          </div>
          <div className="text-center button-home-top">
              <button
                onClick={() => {
                  navigate("/"); // Changed from "/room" to "/role-selection"
                }}
                type="button"
                className="btn border-name-button semi-bold"
              >
                Back to Home
              </button>
            </div>
            </div>
        </div>
      </div>
  );
};

export default RoleSelection;